import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { api } from "../lib/api";
import { getTokenName, getValidLanguage } from "./utils";

const REDIRECT_ON_LOGIN = "redirect_on_login";
// Stored outside class since private
// eslint-disable-next-line
let _id = null;
let _accessToken = null;
let _scopes = null;
let _expiresAt = null;
let _user = null;

export default class Auth {
  constructor(history) {
    this.history = history;
  }

  authorize = async (user, password) => {
    delete api.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["Authorization"];

    const currentLang = getValidLanguage();

    api.defaults.headers.common["Accept-Language"] = currentLang;
    axios.defaults.headers.common["Accept-Language"] = currentLang;

    return await api
      .post("/Account/authenticate", { userCode: user, password: password })
      .then((response) => {
        return { hasError: false, data: response.data, message: "" };
      })
      .catch((error) => {
        return { hasError: true, data: null, message: error?.response?.data?.error };
      });
  };

  login = async (user, password) => {
    let location = this.history.location;
    if (location.pathname === "/login") location = "/";

    const cookieName = getTokenName();
    Cookies.remove(cookieName);

    localStorage.setItem(REDIRECT_ON_LOGIN, JSON.stringify(location));
    localStorage.setItem("TC_CHECKED", "false");
    localStorage.setItem("ALERTAS_CORRIDAS", "false");
    localStorage.setItem("NOTI_AALERTA200_ERRORS", "");
    localStorage.setItem("IS_PLANTA_SELECTED", "false");
    localStorage.setItem("PLANTA_NOMBRE_SELECTED", "");
    Cookies.remove("DASHBOARD_DATA");

    return await this.authorize(user, password);
  };

  getSessionDataFromToken = (token) => {
    const decoded = jwtDecode(token);
    return { expires: decoded.exp, id: decoded.uid, token: token, userName: decoded.sub };
  };

  getAuthInfo = () => {
    return jwtDecode(_accessToken);
  };

  redirectLocation = async () => {
    const redirectLocation = localStorage.getItem(REDIRECT_ON_LOGIN) === "undefined" ? "/" : JSON.parse(localStorage.getItem(REDIRECT_ON_LOGIN));
    this.history.push(redirectLocation);
    localStorage.removeItem(REDIRECT_ON_LOGIN);
  };

  setCookie = async (authenticationResponse) => {
    const token = authenticationResponse?.token;
    const data = this.getSessionDataFromToken(token);
    const cookieName = getTokenName();

    Cookies.set(cookieName, token, { secure: true, sameSite: "strict" });
    this.setSession(data);
  };

  setSession = (authResult) => {
    const currentLang = getValidLanguage();
    // set the time that the access token will expire
    _expiresAt = authResult.expires;
    // If there is a value on the `scope` param from the authResult,
    // use it to set scopes in the session for the user. Otherwise
    // use the scopes as requested. If no scopes were requested,
    // set it to nothing
    _scopes = authResult.scope || this.requestedScopes || "";
    _accessToken = authResult.token;
    _id = authResult.id;
    _user = authResult.userName;
    // se crean default para las creaciones de api subsecuentes
    axios.defaults.headers.common["Authorization"] = "bearer " + authResult.token;
    axios.defaults.headers.common["Accept-Language"] = currentLang;
    // api aun no trae los default, se agregan para esta instancia
    api.defaults.headers.common["Authorization"] = "bearer " + authResult.token;
    api.defaults.headers.common["Accept-Language"] = currentLang;
    this.scheduleTokenRenewal();
  };

  isAuthenticated() {
    const current_time = Date.now() / 1000;
    const result = current_time < _expiresAt;
    return result;
  }

  logout = () => {
    const cookieName = getTokenName();
    Cookies.remove(cookieName);

    localStorage.removeItem("TC_CHECKED");
    Cookies.remove("DASHBOARD_DATA");
    _id = null;
    _accessToken = null;
    _scopes = null;
    _expiresAt = null;
    _user = null;
    this.history.push("/");
  };

  userData = () => {
    return { userId: _id, userName: _user };
  };

  getAccessToken = () => {
    if (!_accessToken) {
      throw new Error("No access token found.");
    }
    return _accessToken;
  };

  userHasScopes(scopes) {
    const grantedScopes = (_scopes || "").split(" ");
    return scopes.every((scope) => grantedScopes.includes(scope));
  }

  silentToken() {
    const cookieName = getTokenName();
    Cookies.remove(cookieName);
    console.log("silentToken: ");
  }

  renewToken(cb) {
    console.log("renewToken: " + JSON.stringify(cb));
    const cookieName = getTokenName();
    const token = Cookies.get(cookieName);

    if (token) {
      const data = this.getSessionDataFromToken(token);
      this.setSession(data);
    }
    // this.auth0.checkSession({}, (err, result) => {
    //   if (err) {
    //     console.log(`Error: ${err.error} - ${err.error_description}.`);
    //   } else {
    //     this.setSession(result);
    //   }
    if (cb) cb(null, null);
    // });
  }

  // implementar silent renew cuando pase el timer...
  scheduleTokenRenewal() {
    const delay = _expiresAt * 1000 - Date.now();
    if (delay > 0) setTimeout(() => this.silentToken(), delay);
  }
}
